import { useMemo, useState } from 'react';
import { Tooltip } from '@primer/react';

import Button from '../common/Button/Button';
import ContextualAssayCreationFrame from './AssayCreationModal';
import ModalOverlay from '../common/ModalOverlay/ModalOverlay';
import useWorkspacePermissions from '../../utils/hooks/use_workspace_permissions';


export const AssayCreationButton = ({ disable, inferenceData }) => {
  const [show, setShow] = useState(false);
  const { canModify } = useWorkspacePermissions();

  const isDisabled = disable || !canModify;
  const tooltipLabel = !canModify
    ? 'Insufficient workspace permissions'
    : 'No inference(s) available';

  const renderHoverText = useMemo(() => {
    if (isDisabled) {
      return (
        <Tooltip aria-label={tooltipLabel}>
          <Button variant="primary" onClick={() => setShow(true)} disabled={isDisabled}>
            + Create Assay
          </Button>
        </Tooltip>
      )
    }

    return (
      <Button variant="primary" onClick={() => setShow(true)}>
        + Create Assay
      </Button>
    )
  }, [isDisabled, tooltipLabel])

  return <>
    {renderHoverText}
    {show && <ModalOverlay active={show} onModalToggle={() => setShow(false)}>
      <div style={{ width: '800px', height: '600px' }}>
        <ContextualAssayCreationFrame onClose={() => setShow(false)} inferenceData={inferenceData} />
      </div>
    </ModalOverlay>
    }
  </>
};

export default AssayCreationButton;
